interface CookieSection {
  title: string;
  content: {
    text?: string;
    items?: string[];
  }[];
}

export const cookiesData: CookieSection[] = [
  {
    title: "Notre Politique de Cookies",
    content: [
      {
        text: "Le site alexandra-grey.fr utilise uniquement des cookies essentiels pour garantir son bon fonctionnement. Nous respectons votre vie privée et n'utilisons aucun cookie publicitaire ou de traçage.",
      },
    ],
  },
  {
    title: "Cookies Essentiels",
    content: [
      {
        text: "Nous utilisons uniquement des cookies techniques pour :",
      },
      {
        items: [
          "Maintenir votre session sécurisée",
          "Mémoriser vos préférences de navigation",
          "Assurer le bon fonctionnement du site",
        ],
      },
    ],
  },
  {
    title: "Aucun Tracking",
    content: [
      {
        text: "Nous nous engageons à :",
      },
      {
        items: [
          "Ne pas utiliser de cookies publicitaires",
          "Ne pas partager vos données avec des tiers",
          "Ne pas intégrer de services de tracking externes",
          "Ne pas revendre vos informations",
        ],
      },
    ],
  },
  {
    title: "Vos Droits",
    content: [
      {
        text: "En tant qu'utilisateur, vous pouvez à tout moment :",
      },
      {
        items: [
          "Configurer votre navigateur pour refuser les cookies (cela peut affecter certaines fonctionnalités)",
          "Supprimer les cookies existants via les paramètres de votre navigateur",
          "Naviguer en mode privé pour limiter le stockage des cookies",
        ],
      },
    ],
  },
  {
    title: "Questions ?",
    content: [
      {
        text: "Pour toute question concernant notre utilisation des cookies, contactez-nous à : agence.next.generation@gmail.com",
      },
    ],
  },
];
